module.exports = __webpack_public_path__ + "static/media/connect-stripe-step-two.362bce1b.jpg";